<template>
  <v-container fluid class="px-0 pt-0 cst-supervision">
		<div>
			<div class="my-4 mx-2">
				<div class="d-flex align-center">
					<div class="flex-grow-1 mr-2" style="border-bottom: 1px solid #ccc;"></div>
					<span class="mx-2 font-weight-bold body-1">Tabla Patrocinios</span>
					<div class="flex-grow-1 ml-2" style="border-bottom: 1px solid #ccc;"></div>
				</div>
				<div class="d-flex justify-center align-center">
					<div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="grey"
									small
									icon
									class="mr-1"
									v-show="showShowMainTable"
									v-bind="attrs"
									v-on="on"
									@click.stop="$store.commit('costbreakdown/setCostBreakdownMainTableModal', true)"
								>
									<v-icon>mdi-eye</v-icon>
								</v-btn>
							</template>
							<span>Visualización Rápida Tabla General</span>
						</v-tooltip>
					</div>
					<v-menu
						v-model="colorPickerVisible"
						:close-on-content-click="false"
						offset-y
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								depressed
								color="grey"
								small
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-palette</v-icon>
							</v-btn>
						</template>
						<v-card>
							<div>
								<div class="pa-2">
									<p class="mb-0 caption font-weight-bold">Selecciona Un Color a Editar</p>
									<p class="mb-1" style="font-size: 10px">Selecciona el color de la tabla que quieres modificar</p>
									<div class="d-flex align-center">
										<v-tooltip bottom
													v-for="(colorVar, key) in colorVars"
													:key="key">
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="white"
													small
													icon
													v-bind="attrs"
													v-on="on"
													:style="{
														border: activeColorKey === colorVar.value ? '2px solid #000' : '2px solid #cecece',
														marginRight: '5px',
														boxShadow: activeColorKey === colorVar.value ? '0 0 5px rgba(0,0,0,0.3)' : 'none'
													}"
													@click="openColorPicker(colorVar.value)"
												>
													<v-icon :color="colors[colorVar.value]">mdi-circle</v-icon>
												</v-btn>
											</template>
											<span>{{colorVar.text}}</span>
										</v-tooltip>
									</div>
								</div>
								<v-color-picker
									v-model="currentColor"
									dot-size="25"
									hide-sliders
									mode="rgba"
									dense
									show-swatches
									swatches-max-height="100"
								/>
							</div>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn text @click="colorPickerVisible = false">Cerrar</v-btn>
							</v-card-actions>
						</v-card>
					</v-menu>
				</div>
			</div>
			<!-- BOTÓN ENVIAR AMBAS TABLAS -->
			<div v-if="hasSentEmailsTable1 && hasSentEmailsTable2" class="d-flex justify-end px-4 mb-4">
				<v-btn
					outlined
					depressed
					color="primary"
					small
					:loading="isLoadingSendEmail"
					@click="sendSupervisionTables"
				>
					<v-icon small>mdi-send</v-icon>
					<div class="ml-1">
						<p class="text-left mb-0">Enviar Ambas Tablas</p>
					</div>
				</v-btn>
			</div>
			<!-- START TABLA 1 -->
			<div class="d-flex align-center justify-space-between mb-2 px-4">
				<div class="d-flex align-center">
					<p class="font-weight-bold mr-4 mb-0">Tabla 1 - Tabla inicial cálculo patrocinio</p>
					<v-btn
						outlined
						depressed
						color="#808080"
						x-small
						:disabled="isTable1Locked"
						@click="addSupervision"
					>
						<v-icon small>mdi-plus</v-icon>
						<div class="ml-1">
							<p class="text-left mb-0">Agregar Tipo de Estructura</p>
						</div>
					</v-btn>
					<v-tooltip bottom v-if="hasSentEmailsTable1">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								depressed
								:color="table1Unlocked ? 'success' : '#808080'"
								small
								class="ml-2"
								v-bind="attrs"
								v-on="on"
								@click="table1Unlocked = !table1Unlocked"
							>
								<v-icon>{{ table1Unlocked ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>
							</v-btn>
						</template>
						<span>{{ table1Unlocked ? 'Bloquear tabla' : 'Desbloquear para editar' }}</span>
					</v-tooltip>
				</div>
				<div class="d-flex align-center">
					<v-btn
						outlined
						depressed
						color="success"
						x-small
						class="mr-2"
						:disabled="!supervisionTotals.supervision_first?.totalUf"
						:loading="isLoadingSendEmailTable1"
						@click="sendSupervisionTable1"
					>
						<v-icon small>mdi-send</v-icon>
						<div class="ml-1">
							<p class="text-left mb-0">Enviar Tabla 1</p>
						</div>
					</v-btn>
					<CompanyTemplatesHandler
						:type="'supervision'"
						:itemContent="localSupervisions"
						color="#808080"
						:disabled="isTable1Locked"
						@template-content-selected="(template) => templateContentSelected(template, 1)"/>
				</div>
			</div>
			<!-- Selector impuesto Tabla 1 + configuración cuotas -->
			<v-simple-table style="zoom: 90%" class="custom-table-cost caption" :class="{ 'blocked-content-cost-table': isTable1Locked }">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
							<td style="vertical-align: middle;min-width: 160px;max-width: 160px;width: 160px;"><p class="text-center mb-0 caption font-weight-bold" >Tipo Estructura</p></td>
							<td style="vertical-align: middle;min-width: 90px;max-width: 90px;width: 90px;"><p class="text-center mb-0 caption font-weight-bold" >M2</p></td>
							<td style="vertical-align: middle;min-width: 130px;"><p class="text-center mb-0 caption font-weight-bold" >Valor x M2</p></td>
							<td style="vertical-align: middle;min-width: 110px;"><p class="text-center mb-0 caption font-weight-bold">Valor UF</p></td>
							<td style="vertical-align: middle;min-width: 130px;"><p class="text-center mb-0 caption font-weight-bold" >SubTotal</p></td>
							<td style="vertical-align: middle;min-width: 150px;max-width: 150px;width: 150px;">
								<p class="mb-0 text-center" style="font-size: 10px;">Patrocinio Neto</p>
								<v-select
									v-model="supervisionPercentA"
									:items="percentOptions"
									:menu-props="{ top: true, offsetY: true }"
									label=""
									class="custom-height-search custom-height-calendar mr-1 w-100 mb-3 mt-0 colored-supervision-select"
									outlined
									dense
									required
									:color="calcFontColor(supervisionTableColor)"
									:disabled="isTable1Locked"
									item-text="text"
									item-value="value"
									@change="onSupervisionPercentAChange"
									:style="{ 
										'--supervision-color': calcFontColor(supervisionTableColor)
									}"
								></v-select>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<v-select
									v-model="table1Tax"
									:items="taxesOptions"
									:loading="$store.state.general.loadingTaxesOptions"
									:menu-props="{ offsetY: true }"
									:label="table1Tax ? 'Tipo impuesto: ' + table1Tax.tax.name : 'Tipo Impuesto'"
									class="custom-height-search custom-height-calendar mr-1 w-100 my-3 colored-supervision-select"
									outlined
									dense
									return-object
									item-value="id"
									:color="calcFontColor(supervisionTableColor)"
									:style="{ 
										'--supervision-color': calcFontColor(supervisionTableColor)
									}"
								>
									<template v-slot:item="data">
										<v-list-item-content>
											<v-list-item-title>
												<div class="d-flex align-center justify-space-between" style="min-width: 180px;">
													<span>{{ data.item.tax.name }}</span>
													<b class="ml-2">{{ data.item.tax.value }}%</b>
												</div>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<div class="d-flex align-center flex-1" style="min-width: 0; width: 100%;" :style="{ color: calcFontColor(supervisionTableColor) }">
											<b class="caption ml-1 flex-shrink-0">{{ data.item.tax.value }}%</b>
										</div>
									</template>
								</v-select>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" class="supervision-total-col"><p class="text-center mb-0 font-weight-bold" style="font-size: 14px;">Total</p></td>
							<td
								v-for="(quota, qi) in localQuotas"
								:key="'th1-'+quota.uid"
								class="text-center supervision-quota-col"
								:style="{ 'vertical-align': 'middle', 'min-width': '200px', 'padding': '6px 4px', '--supervision-color': calcFontColor(supervisionTableColor) }">
								<div class="d-flex justify-center mb-1" style="gap: 10px;">
									<p class="mb-0 font-weight-bold mb-1" :style="{ color: calcFontColor(supervisionTableColor), fontSize: '13px' }">Cuota {{ qi + 1 }}</p>
									<v-btn icon x-small :color="calcFontColor(supervisionTableColor)" :disabled="localQuotas.length <= 1" @click="deleteQuota(qi)">
										<v-icon small>mdi-delete-outline</v-icon>
									</v-btn>
								</div>
								<div class="d-flex align-center justify-center" style="gap: 4px;">
									<v-text-field
										v-model.number="quota.percent"
										@input="enforcePercentLimit(qi)"
										label="%"
										type="number" min="0" max="100"
										dense outlined hide-details
										:disabled="isTable1Locked"
										:color="calcFontColor(supervisionTableColor)"
										class="caption flex-grow-0 colored-supervision-select custom-height-search custom-height-calendar"
										style="font-size: 12px;"
									></v-text-field>
									<!-- <v-text-field
										v-model="quota.name"
										label="Nombre"
										dense outlined hide-details
										:disabled="isTable1Locked"
										:color="calcFontColor(supervisionTableColor)"
										class="caption colored-supervision-select custom-height-search custom-height-calendar"
										style="font-size: 12px;"
									></v-text-field> -->
								</div>
							</td>
							<td style="vertical-align: middle; width: 50px; text-align: center;">
								<v-btn icon small :disabled="isTable1Locked || localQuotas.some(q => q.id === null)" :loading="localQuotas.some(q => q.id === null)" @click="addQuota" :color="calcFontColor(supervisionTableColor)">
									<v-icon>mdi-plus-circle-outline</v-icon>
								</v-btn>
							</td>
						</tr>
					</thead>
					<tbody v-for="(supervision, index) in localSupervisions" :key="'supervision_'+index">
						<tr>
							<td style="vertical-align: top;min-width: 100px;max-width: 120px;" :width="colWidths[0]">
								<v-select
									v-model="supervision.detail"
									:items="detailOptions"
									:menu-props="{ top: true, offsetY: true }"
									label="Tipo Estructura"
									class="custom-height-search custom-height-calendar mb-0 mr-1 w-100 mt-3"
									outlined
									dense
									required
									:disabled="isTable1Locked"
									item-text="text"
									item-value="id"
									@change="onSupervisionDetailChange(supervision)"
								></v-select>
							</td>
							<td style="vertical-align: top;min-width: 85px;" :width="colWidths[1]">
									<v-text-field
										v-model="supervision.meters"
										type="text"
										label="M2"
										outlined
										required
										dense
										hide-details
										:disabled="isTable1Locked"
										class="custom-height-search custom-height-calendar mt-3"
										style="font-size: 14px;"
										:rules="requiredRule"
										@keydown.enter.prevent
										@keypress="onKeyPress"
										@input="onSupervisionMetersInput(supervision)"
									></v-text-field>
							</td>
							<td style="vertical-align: middle;min-width: 85px;" :width="colWidths[1]">
								<div>
									<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf | toThousandFilter(2) }}</p>
									<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) | toThousandFilter }}</p>
								</div>
								<!-- <div v-if="currency == 'uf'">
									<v-text-field
										v-model="supervision.meters_uf"
										type="number"
										label="Valor x M2 (UF)"
										outlined
										required
										dense
										hide-details
										class="custom-height-search custom-height-calendar mt-3"
										style="font-size: 14px;"
										:rules="requiredRule"
										@keydown.enter.prevent
										@keypress="onKeyPress"
										@input="sanitizeNumber(supervision, 'meters_uf', {allowDecimal: true})"
									></v-text-field>
									<p class="mb-0 text-right mt-1"><b class="caption">UF</b> ${{ supervision.meters_uf | toThousandFilter(2) }}</p>
									<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_clp | toThousandFilter }}</p>
								</div>
								<div v-else>
									<v-text-field
										v-model="supervision.meters_clp"
										type="number"
										label="Valor x M2 (CLP)"
										outlined
										required
										dense
										hide-details
										class="custom-height-search custom-height-calendar mt-3"
										style="font-size: 14px;"
										:rules="requiredRule"
										@keydown.enter.prevent
										@keypress="validateCLP"
										@input="sanitizeNumber(supervision, 'meters_clp')"
									></v-text-field>
									<p class="mb-0 text-right mt-1"><b class="caption">UF</b> ${{ supervision.meters_uf | toThousandFilter(2) }}</p>
								</div> -->
							</td>
							<td style="vertical-align: middle;min-width: 110px;">
								<div v-if="supervision.uf_value">
									<p class="mb-0 text-right mt-1">${{supervision.uf_value.uf_value | toThousandFilter(2) }}</p>
									<p class="mb-0 text-right mt-0">Uf al {{supervision.uf_value.date | toDate }}</p>
								</div>
								<div v-else>--</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[5]">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) * ((supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) * ((supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" class="supervision-total-col">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter }}</p>
							</td>
							<td
								v-for="quota in localQuotas"
								:key="'row1-'+quota.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle; min-width: 200px;">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) * (quota.percent/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) * (quota.percent/100) | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;width:50px;">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="error"
											:disabled="isTable1Locked"
											@click="deleteSupervision(supervision)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-delete-outline</v-icon>
										</v-btn>
									</template>
									<span>Eliminar Item</span>
								</v-tooltip>
							</td>
						</tr>
					</tbody>
					<!-- Totals -->
					<tbody>
						<tr class="header-rows-custom" :style="{ backgroundColor: colors['footerSupervisionTables'], color: calcFontColor(colors['footerSupervisionTables']) }">
							<td style="width: 150px; vertical-align: middle;" class="text-left">
								<p class="mb-0 font-weight-bold" style="font-size: 14px;">Total</p>
							</td>
							<td style="vertical-align: middle;min-width: 90px;">
								<p class="mb-0 text-right mt-1 font-weight-bold" style="font-size: 13px;">{{ totalMetersTable1 | toThousandFilter(2) }} <b class="caption">M2</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalValuePerM2Table1.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalValuePerM2Table1.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 110px;"></td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalSubtotalTable1.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalSubtotalTable1.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalFeeTable1.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalFeeTable1.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalIvaTable1.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalIvaTable1.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]" class="py-2 supervision-total-col">
								<p class="mb-0 text-right mt-1 font-weight-bold" style="font-size: 14px;">{{ supervisionTotals.supervision_first?.totalUf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1" style="font-size: 14px;">${{ supervisionTotals.supervision_first?.totalClp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td
								v-for="quota in localQuotas"
								:key="'tot1-'+quota.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle; min-width: 200px;">
								<p class="mb-0 text-right mt-1 font-weight-bold" style="font-size: 13px;">{{ supervisionTotals.supervision_first?.totalUf * (quota.percent/100) | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1" style="font-size: 13px;">${{ supervisionTotals.supervision_first?.totalClp * (quota.percent/100) | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;width: 50px;"></td>
						</tr>

					</tbody>
				</template>
			</v-simple-table>
			<!-- END TABLA 1 -->
			<v-divider class="my-4"></v-divider>
			<!-- START TABLA 2 -->
			<div class="d-flex align-center justify-space-between mb-2 px-4">
				<div class="d-flex align-center">
					<p class="font-weight-bold mr-4 mb-0">Tabla 2 - Tabla definitiva de cálculo de patrocinio</p>
					<v-btn
						outlined
						depressed
						color="#808080"
						x-small
						:disabled="isTable2Locked || !hasSentEmailsTable1"
						@click="addSupervisionB"
					>
						<v-icon small>mdi-plus</v-icon>
						<div class="ml-1">
							<p class="text-left mb-0">Agregar Tipo de Estructura</p>
						</div>
					</v-btn>
					<v-tooltip bottom v-if="hasSentEmailsTable2">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								depressed
								:color="table2Unlocked ? 'success' : '#808080'"
								small
								class="ml-2"
								v-bind="attrs"
								v-on="on"
								@click="table2Unlocked = !table2Unlocked"
							>
								<v-icon>{{ table2Unlocked ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>
							</v-btn>
						</template>
						<span>{{ table2Unlocked ? 'Bloquear tabla' : 'Desbloquear para editar' }}</span>
					</v-tooltip>
				</div>
				<div class="d-flex align-center">
					<v-btn
						outlined
						depressed
						color="success"
						x-small
						class="mr-2"
						:disabled="!supervisionTotals.supervision_second?.totalUf"
						:loading="isLoadingSendEmailTable2"
						@click="sendSupervisionTable2"
					>
						<v-icon small>mdi-send</v-icon>
						<div class="ml-1">
							<p class="text-left mb-0">Enviar Tabla 2</p>
						</div>
					</v-btn>
					<CompanyTemplatesHandler
						:type="'supervision'"
						:itemContent="localSupervisionsB"
						color="#808080"
						:disabled="isTable2Locked || !hasSentEmailsTable1"
						@template-content-selected="(template) => templateContentSelected(template, 2)"/>
				</div>
			</div>
			<!-- Selector impuesto Tabla 2 -->
			<v-simple-table style="zoom: 90%" class="custom-table-cost caption" :class="{ 'blocked-content-cost-table': isTable2Locked || !hasSentEmailsTable1 }">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
							<td style="vertical-align: middle;min-width: 120px;max-width: 120px;width: 120px;"><p class="text-center mb-0 caption font-weight-bold" >Tipo Estructura</p></td>
							<td style="vertical-align: middle;min-width: 90px;max-width: 90px;width: 90px;"><p class="text-center mb-0 caption font-weight-bold" >M2</p></td>
							<td style="vertical-align: middle;min-width: 130px;"><p class="text-center mb-0 caption font-weight-bold" >Valor x M2</p></td>
							<td style="vertical-align: middle;min-width: 110px;"><p class="text-center mb-0 caption font-weight-bold">Valor UF</p></td>
							<td style="vertical-align: middle;min-width: 130px;"><p class="text-center mb-0 caption font-weight-bold" >SubTotal</p></td>
							<td style="vertical-align: middle;min-width: 150px;max-width: 150px;width: 150px;">
								<p class="mb-0 text-center" style="font-size: 10px;">Patrocinio Neto</p>
								<v-select
									v-model="supervisionPercentB"
									:items="percentOptions"
									:menu-props="{ top: true, offsetY: true }"
									label="%"
									class="custom-height-search custom-height-calendar mr-1 w-100 mb-3 mt-0 colored-supervision-select"
									outlined
									dense
									required
									:color="calcFontColor(supervisionTableColor)"
									:disabled="isTable2Locked"
									item-text="text"
									item-value="value"
									@change="onSupervisionPercentBChange"
									:style="{ 
										'--supervision-color': calcFontColor(supervisionTableColor)
									}"
								></v-select>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<v-select
									v-model="table2Tax"
									:items="taxesOptions"
									:loading="$store.state.general.loadingTaxesOptions"
									:menu-props="{ offsetY: true }"
									:label="table2Tax ? 'Tipo impuesto: ' + table2Tax.tax.name : 'Tipo Impuesto'"
									class="custom-height-search custom-height-calendar mr-1 w-100 my-3 colored-supervision-select"
									outlined
									dense
									return-object
									item-value="id"
									:color="calcFontColor(supervisionTableColor)"
									:style="{ 
										'--supervision-color': calcFontColor(supervisionTableColor)
									}"
								>
									<template v-slot:item="data">
										<v-list-item-content>
											<v-list-item-title>
												<div class="d-flex align-center justify-space-between" style="min-width: 180px;">
													<span>{{ data.item.tax.name }}</span>
													<b class="ml-2">{{ data.item.tax.value }}%</b>
												</div>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<div class="d-flex align-center flex-1" style="min-width: 0; width: 100%;" :style="{ color: calcFontColor(supervisionTableColor) }">
											<b class="caption ml-1 flex-shrink-0">{{ data.item.tax.value }}%</b>
										</div>
									</template>
								</v-select>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" class="supervision-total-col"><p class="text-center mb-0 font-weight-bold" style="font-size: 14px;">Total</p></td>
							<td
								v-for="(quota, qi) in localQuotas"
								:key="'th2-'+quota.uid"
								class="text-center supervision-quota-col"
								style="vertical-align: middle; min-width: 200px; padding: 6px 4px;">
								<p class="mb-0 font-weight-bold" style="font-size: 13px;">Cuota {{ qi + 1 }}</p>
								<p class="mb-0" style="font-size: 10px;">{{ quota.percent }}% — {{ quota.name }}</p>
							</td>
							<td style="vertical-align: middle;width: 50px;"></td>
						</tr>
					</thead>
					<tbody v-for="(supervision, index) in localSupervisionsB" :key="'supervision_'+index">
						<tr>
							<td style="vertical-align: top;min-width: 100px;max-width: 120px;" :width="colWidths[0]">
								<v-select
									v-model="supervision.detail"
									:items="detailOptions"
									:menu-props="{ top: true, offsetY: true }"
									label="Tipo Estructura"
									class="custom-height-search custom-height-calendar mb-0 mr-1 w-100 mt-3"
									outlined
									dense
									required
									:disabled="!supervisionTotals.supervision_first?.totalUf"
									item-text="text"
									item-value="id"
									@change="onSupervisionDetailChange(supervision)"
								></v-select>
								<!-- <v-text-field
									v-model="supervision.detail"
									label="Detalle"
									outlined
									required
									dense
									hide-details
									class="custom-height-search custom-height-calendar mt-3"
									style="font-size: 14px;"
								></v-text-field> -->
							</td>
							<td style="vertical-align: top;min-width: 85px;" :width="colWidths[1]">
									<v-text-field
										v-model="supervision.meters"
										type="text"
										label="M2"
										outlined
										required
										dense
										hide-details
										:disabled="!supervisionTotals.supervision_first?.totalUf"
										class="custom-height-search custom-height-calendar mt-3"
										style="font-size: 14px;"
										:rules="requiredRule"
										@keydown.enter.prevent
										@keypress="onKeyPress"
										@input="onSupervisionMetersInput(supervision)"
									></v-text-field>
							</td>
							<td style="vertical-align: middle;min-width: 85px;" :width="colWidths[1]">
								<div>
									<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf | toThousandFilter(2) }}</p>
									<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) | toThousandFilter }}</p>
								</div>
								<!-- <div v-if="currency == 'uf'">
									<v-text-field
										v-model="supervision.meters_uf"
										type="number"
										label="Valor x M2 (UF)"
										outlined
										required
										dense
										hide-details
										class="custom-height-search custom-height-calendar mt-3"
										style="font-size: 14px;"
										:rules="requiredRule"
										@keydown.enter.prevent
										@keypress="onKeyPress"
										@input="sanitizeNumber(supervision, 'meters_uf', {allowDecimal: true})"
									></v-text-field>
									<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_clp | toThousandFilter }}</p>
								</div>
								<div v-else>
									<v-text-field
										v-model="supervision.meters_clp"
										type="number"
										label="Valor x M2 (CLP)"
										outlined
										required
										dense
										hide-details
										class="custom-height-search custom-height-calendar mt-3"
										style="font-size: 14px;"
										:rules="requiredRule"
										@keydown.enter.prevent
										@keypress="validateCLP"
										@input="sanitizeNumber(supervision, 'meters_clp')"
									></v-text-field>
									<p class="mb-0 text-right mt-1"><b class="caption">UF</b> ${{ supervision.meters_uf | toThousandFilter(2) }}</p>
								</div> -->
							</td>
							<td style="vertical-align: middle;min-width: 110px;">
								<div v-if="supervision.uf_value">
									<p class="mb-0 text-right mt-1">${{supervision.uf_value.uf_value | toThousandFilter(2) }}</p>
									<p class="mb-0 text-right mt-0 caption">Uf al {{supervision.uf_value.date | toDate }}</p>
								</div>
								<div v-else>--</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[5]">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) * ((supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) * ((supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" class="supervision-total-col">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) | toThousandFilter }}</p>
							</td>
							<td
								v-for="quota in localQuotas"
								:key="'row2-'+quota.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle; min-width: 200px;">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervision.meters_uf * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) * (quota.percent/100) | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervision.meters_uf * (supervision.uf_value && supervision.uf_value.uf_value || 0) * supervision.meters * (supervision.percent/100) * (1 + (supervision.tax && supervision.tax.value || 19)/100) * (quota.percent/100) | toThousandFilter }}</p>
							</td>
							<td style="vertical-align: middle;width:50px;">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="error"
											:disabled="isTable2Locked || (!supervisionTotals.supervision_first?.totalUf && !hasSentEmailsTable1)"
											@click="deleteSupervisionB(supervision)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-delete-outline</v-icon>
										</v-btn>
									</template>
									<span>Eliminar Item</span>
								</v-tooltip>
							</td>
						</tr>
					</tbody>
					<!-- Totals -->
					<tbody>
						<tr class="header-rows-custom" :style="{ backgroundColor: colors['footerSupervisionTables'], color: calcFontColor(colors['footerSupervisionTables']) }">
							<td style="width: 150px; vertical-align: middle;" class="text-left">
								<p class="mb-0 font-weight-bold" style="font-size: 14px;">Total</p>
							</td>
							<td style="vertical-align: middle;min-width: 90px;">
								<p class="mb-0 text-right mt-1 font-weight-bold" style="font-size: 13px;">{{ totalMetersTable2 | toThousandFilter(2) }} <b class="caption">M2</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalValuePerM2Table2.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalValuePerM2Table2.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 110px;"></td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalSubtotalTable2.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalSubtotalTable2.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalFeeTable2.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalFeeTable2.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 text-right mt-1">{{ totalIvaTable2.uf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1">${{ totalIvaTable2.clp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]" class="py-2 supervision-total-col">
								<p class="mb-0 text-right mt-1 font-weight-bold" style="font-size: 14px;">{{ supervisionTotals.supervision_second?.totalUf | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1" style="font-size: 14px;">${{ supervisionTotals.supervision_second?.totalClp | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td
								v-for="quota in localQuotas"
								:key="'tot2-'+quota.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle; min-width: 200px;">
								<p class="mb-0 text-right mt-1 font-weight-bold" style="font-size: 13px;">{{ supervisionTotals.supervision_second?.totalUf * (quota.percent/100) | toThousandFilter(2) }} <b class="caption">UF</b></p>
								<p class="mb-0 text-right mt-1" style="font-size: 13px;">${{ supervisionTotals.supervision_second?.totalClp * (quota.percent/100) | toThousandFilter }} <b class="caption">CLP</b></p>
							</td>
							<td style="vertical-align: middle;width: 50px;"></td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
			<!-- END TABLA 2 -->
			<v-divider class="my-4"></v-divider>
			<!-- START DIFF TABLE -->
			<!-- <div class="d-flex align-center justify-space-between mb-2 px-4">
				<p class="font-weight-bold mr-4 mb-0">Pagos Patrocinio</p>
				<v-btn
					outlined
					depressed
					color="black"
					small
					@click="addSupervisionPayment"
				>
					<v-icon small>mdi-plus</v-icon>
					<p class="mb-0">Agregar Cuota</p>
				</v-btn>
			</div>
			<v-simple-table style="zoom: 90%" class="custom-table-cost caption">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
							<td style="vertical-align: middle;min-width: 130px;" rowspan="2"></td>
							<td style="vertical-align: middle;min-width: 130px;" rowspan="2"><p class="text-center mb-0 caption font-weight-bold" >Total</p></td>
							<td v-for="(costsPayment, indexPayment) in costsPayments"
								colspan="2"
								:key="'projectPlannedStageHeaders_'+costsPayment.id"
								:style="{
									width: 'calc((100% - 130px) / ' + costsPayments.length + ')',
									minWidth: '100px',
									verticalAlign: 'top',
									textAlign: 'center'
								}">
								<p class="text-center mb-0" style="font-size: 10px;">Cuota / EP {{indexPayment + 1}}</p>
								<p class="text-center mb-0 caption font-weight-bold">{{costsPayment.stage?.name}}{{ costsPayment.stage?.description ? ': '+costsPayment.stage?.description:''}}</p>
							</td>
							<td style="vertical-align: middle;width: 50px;max-width: 50px;"></td>
						</tr>
						<tr class="header-rows-custom" :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
							<template v-for="(costsPayment) in costsPayments">
								<td
									:key="'projectPlannedStageHeadersA_'+costsPayment.id"
									style="width: 40px;min-width: 40px;"
									class="px-1">
									<p class="text-center mb-0" style="font-size: 10px;">%</p>
								</td>
								<td
									:key="'projectPlannedStageHeadersB_'+costsPayment.id"
									style="width:90px;min-width: 90px;"
									class="px-1">
									<p class="text-center mb-0" style="font-size: 10px;">Monto Cuota</p>
								</td>
							</template>
							<td style="vertical-align: middle;width: 50px;max-width: 50px;"></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 font-weight-bold">Tabla 1</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]" class="py-2">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervisionTotals.supervision_first?.totalUf | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervisionTotals.supervision_first?.totalClp | toThousandFilter }}</p>
							</td>
							<template
								v-for="costsPayment in costsPayments">
								<td
									:key="'mpA_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
									<v-text-field
										:ref="'supervisionA_'+costsPayment.id"
										:value="getPaymentValue(costsPayment, 'supervisionA')?.amount"
										class="custom-height-search custom-height-calendar custom-type-number mb-0"
										min="0"
										max="100"
										type="number"
										hide-details
										dense
										outlined
										:rules="requiredRule"
										:disabled="!!supervisionTotals.supervision_second?.totalUf"
										@input="val => preUpdateValue(costsPayment, 'supervisionA', val)"
									></v-text-field>
								</td>
								<td 
									:key="'mpB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div v-if="getPaymentValue(costsPayment, 'supervisionA')">
										<p class="text-right mb-0 caption font-weight-bold" >{{supervisionTotals.supervision_first?.totalUf * getPaymentValue(costsPayment, 'supervisionA').amount/100 | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{supervisionTotals.supervision_first?.totalClp * getPaymentValue(costsPayment, 'supervisionA').amount/100 | toThousandFilter}} CLP</p>
									</div>
									<div v-else>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
									</div>
								</td>
							</template>
							<td style="vertical-align: middle;width: 50px;max-width: 50px;"></td>
						</tr>
						<tr>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 font-weight-bold">Tabla 2</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]" class="py-2">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervisionTotals.supervision_second?.totalUf | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervisionTotals.supervision_second?.totalClp | toThousandFilter }}</p>
							</td>
							<template
								v-for="costsPayment in costsPayments">
								<td
									:key="'mpA_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
									<v-text-field
										:ref="'supervisionB_'+costsPayment.id"
										:value="getPaymentValue(costsPayment, 'supervisionB')?.amount"
										class="custom-height-search custom-height-calendar custom-type-number mb-0"
										min="0"
										max="100"
										type="number"
										hide-details
										dense
										outlined
										:disabled="!supervisionTotals.supervision_second?.totalUf"
										:rules="requiredRule"
										@input="val => preUpdateValue(costsPayment, 'supervisionB', val)"
									></v-text-field>
								</td>
								<td 
									:key="'mpB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div v-if="getPaymentValue(costsPayment, 'supervisionB')">
										<p class="text-right mb-0 caption font-weight-bold" >{{supervisionTotals.supervision_second?.totalUf * getPaymentValue(costsPayment, 'supervisionB').amount/100 | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{supervisionTotals.supervision_second?.totalClp * getPaymentValue(costsPayment, 'supervisionB').amount/100 | toThousandFilter}} CLP</p>
									</div>
									<div v-else>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
									</div>
								</td>
							</template>
							<td style="vertical-align: middle;width: 50px;max-width: 50px;"></td>
						</tr>
						<tr>
							<td style="vertical-align: middle;min-width: 130px;">
								<p class="mb-0 font-weight-bold">Diferencia</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]" class="py-2">
								<p class="mb-0 text-right mt-1"><b class="caption">UF</b> {{ supervisionTotals.difference?.totalUf | toThousandFilter(2) }}</p>
								<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ supervisionTotals.difference?.totalClp | toThousandFilter }}</p>
							</td>
							<template
								v-for="costsPayment in costsPayments">
								<td
									:key="'mpC_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
								</td>
								<td 
									:key="'mpB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div>
										<p class="text-right mb-0 caption font-weight-bold" >{{getSubtotalPaymentUf(costsPayment) | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{getSubtotalPaymentClp(costsPayment) | toThousandFilter}} CLP</p>
									</div>
								</td>
							</template>
							<td style="vertical-align: middle;width: 50px;max-width: 50px;"></td>
						</tr>
					</tbody>
				</template>
			</v-simple-table> -->
			<!-- END DIFF TABLE -->

			<!-- START ADJUSTMENT TABLE -->
			<v-divider class="my-4"></v-divider>
			<div class="px-4 mb-2">
				<p class="font-weight-bold mb-0">Ajuste por disminución / aumento de superficie y/o cambio de materialidad</p>
			</div>
			<v-simple-table style="zoom: 90%" class="custom-table-cost adj-summary-table caption">
				<template v-slot:default>
					<thead>
						<!-- Ghost row: define anchos de columna sin colspan para alinear con Tabla 2 -->
						<tr style="height:0;line-height:0;overflow:hidden;border:none;">
							<td style="height:0;padding:0;border:0;overflow:hidden;width:120px;min-width:120px;max-width:120px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;width:90px;min-width:90px;max-width:90px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;min-width:130px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;min-width:110px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;min-width:130px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;width:150px;min-width:150px;max-width:150px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;min-width:130px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;min-width:130px;"></td>
							<td v-for="q in localQuotas" :key="'adj-ghost-'+q.uid" style="height:0;padding:0;border:0;overflow:hidden;min-width:200px;"></td>
							<td style="height:0;padding:0;border:0;overflow:hidden;width:50px;"></td>
						</tr>
						<tr class="header-rows-custom" :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
							<td colspan="7"></td>
							<td class="text-center supervision-total-col" style="min-width: 130px;">
								<p class="mb-0 font-weight-bold" style="font-size: 14px;">Total</p>
							</td>
							<td
								v-for="(quota,index) in localQuotas"
								:key="'adj-header-'+quota.uid"
								class="text-center supervision-quota-col"
								style="min-width: 200px;">
								<p class="mb-0 font-weight-bold" style="font-size: 13px;">Cuota {{ index + 1 }}</p>
								<p class="mb-0" style="font-size: 10px;">{{ quota.percent }}% — {{ quota.name }}</p>
							</td>
							<td style="width: 50px;"></td>
						</tr>
					</thead>
					<tbody>
						<!-- Cuotas por tabla -->
						<tr>
							<td style="vertical-align: middle;" colspan="7">
								<p class="mb-0 font-weight-bold">Tabla 1 - Tabla inicial cálculo patrocinio</p>
							</td>
							<td class="text-right supervision-total-col" style="vertical-align: middle;">
								<p class="mb-0 font-weight-bold">{{ supervisionTotalsDynamic.supervision_first.totalUf | toThousandFilter(2) }} UF</p>
								<p class="mb-0">${{ supervisionTotalsDynamic.supervision_first.totalClp | toThousandFilter }}</p>
							</td>
							<td
								v-for="q in adjustmentSummaryDynamic"
								:key="'adj-t1-'+q.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle;">
								<p class="mb-0 font-weight-bold">{{ q.t1Uf | toThousandFilter(2) }} UF</p>
								<p class="mb-0">${{ q.t1Clp | toThousandFilter }}</p>
							</td>
							<td style="width: 50px;"></td>
						</tr>
						<tr>
							<td style="vertical-align: middle;" colspan="7">
								<p class="mb-0 font-weight-bold">Tabla 2 - Tabla definitiva de cálculo de patrocinio</p>
							</td>
							<td class="text-right supervision-total-col" style="vertical-align: middle;">
								<p class="mb-0 font-weight-bold">{{ supervisionTotalsDynamic.supervision_second.totalUf | toThousandFilter(2) }} UF</p>
								<p class="mb-0">${{ supervisionTotalsDynamic.supervision_second.totalClp | toThousandFilter }}</p>
							</td>
							<td
								v-for="q in adjustmentSummaryDynamic"
								:key="'adj-t2-'+q.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle;">
								<p class="mb-0 font-weight-bold">{{ q.t2Uf | toThousandFilter(2) }} UF</p>
								<p class="mb-0">${{ q.t2Clp | toThousandFilter }}</p>
							</td>
							<td style="width: 50px;"></td>
						</tr>
						<!-- Diferencia por cuota -->
						<tr v-if="(supervisionTotalsDynamic.supervision_second.totalUf || 0) !== (supervisionTotalsDynamic.supervision_first.totalUf || 0)">
							<td style="vertical-align: middle;" colspan="7">
								<div class="d-flex align-center justify-space-between" style="gap: 12px;">
									<div>
										<p class="mb-0 font-weight-bold" :style="{ color: (supervisionTotalsDynamic.supervision_second.totalUf - supervisionTotalsDynamic.supervision_first.totalUf) > 0 ? '#FF120B' : 'green' }">Total Diferencia</p>
										<p class="mb-0" :style="{ color: (supervisionTotalsDynamic.supervision_second.totalUf - supervisionTotalsDynamic.supervision_first.totalUf) > 0 ? '#FF120B' : 'green' }">
											<span v-if="(supervisionTotalsDynamic.supervision_second.totalUf - supervisionTotalsDynamic.supervision_first.totalUf) > 0">A favor empresa</span>
											<span v-else-if="(supervisionTotalsDynamic.supervision_second.totalUf - supervisionTotalsDynamic.supervision_first.totalUf) < 0">A favor cliente</span>
										</p>
									</div>
									<div>
										<supervision-diff-detail-menu
											:supervision-totals-dynamic="supervisionTotalsDynamic"
											:adjustment-summary-dynamic="adjustmentSummaryDynamic"
											:local-quotas="localQuotas"
											:supervision-table-color="supervisionTableColor"
											:next-supervision-quota="nextSupervisionQuota"
											:next-summary-totals="nextSummaryTotals"
											:has-sent-emails-table1="hasSentEmailsTable1"
											:today-uf-value="todayUfValue"
											@isOpen="isOpen => isDiffDetailOpen = isOpen"
										/>
									</div>
								</div>
							</td>
							<td class="text-right supervision-total-col" style="vertical-align: middle;">
								--
							</td>
							<td
								v-for="(q) in adjustmentSummaryDynamic"
								:key="'adj-diff-'+q.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle;">
								<div class="d-flex align-center justify-end" style="gap: 12px;">
									<div v-if="q.diffUf" :style="{ color: q.diffUf > 0 ? '#FF120B' : 'green' }">
										<p class="mb-0 font-weight-bold">
											{{ (q.diffUf || 0) | toThousandFilter(2) }} UF
										</p>
										<p class="mb-0">
											${{ (q.diffClp || 0) | toThousandFilter }}
										</p>
									</div>
									<div v-else>
										--
									</div>
								</div>
							</td>
							<td style="width: 50px;"></td>
						</tr>
						<tr v-if="(supervisionTotalsDynamic.supervision_second.totalUf || 0) !== (supervisionTotalsDynamic.supervision_first.totalUf || 0)">
							<td style="vertical-align: middle;font-size:18px;" colspan="7">
							</td>
							<td class="text-right supervision-total-col" style="vertical-align: middle;font-size:18px;">
								--
							</td>
							<td
								v-for="(q,qi) in adjustmentSummaryDynamic"
								:key="'adj-verify-'+q.uid"
								class="text-right supervision-quota-col"
								style="vertical-align: middle;font-size:18px;">
								<div v-if="q.diffUf">
									<p class="mb-0 font-weight-bold">
										{{ (q.diffUf || 0) | toThousandFilter(2) }} UF
									</p>
									<p class="mb-0">
										${{ (q.diffClp || 0) | toThousandFilter }}
									</p>
								</div>
								<div v-else-if="qi > 0">
									<p class="mb-0 font-weight-bold">{{ q.t2Uf | toThousandFilter(2) }} UF</p>
									<p class="mb-0">${{ q.t2Clp | toThousandFilter }}</p>
								</div>
								<div v-else>
									--
								</div>
							</td>
							<td style="width: 50px;"></td>
						</tr>
						<tr>
							<td style="vertical-align: middle;font-size:18px;" colspan="7">
								<p class="mb-0 font-weight-bold">Total a pagar</p>
							</td>
							<td class="text-center supervision-total-col"></td>
							<td
								v-for="(q) in adjustmentSummaryDynamic"
								:key="'fila-totals-'+q.uid"
								class="text-center supervision-quota-col"
								style="vertical-align: middle;font-size:18px;text-align:right;">
								<div v-if="q.finalUf">
									<p class="mb-0 font-weight-bold text-right" style="font-size:18px;">
										{{ q.finalUf | toThousandFilter(2) }} UF
									</p>
									<p class="mb-0 text-right" style="font-size:18px;">
										${{ q.finalClp | toThousandFilter }}
									</p>
								</div>
							</td>
							<td style="width: 50px;"></td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
			<!-- END ADJUSTMENT TABLE -->

			<!-- START PAYMENT DETAIL TABLE -->
			<v-divider class="my-4"></v-divider>
			<div class="px-4 mb-2">
				<p class="font-weight-bold mb-0">Detalle de pagos patrocinio</p>
				<p class="caption grey--text mb-2">Registro de pagos por cuota</p>
			</div>
			<div style="width: 100%;">
			<v-simple-table style="zoom: 90%" class="custom-table-cost payment-fixed-table caption">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
							<td style="width: 100px;">CUOTA</td>
							<td class="text-right" style="width: 130px;">PACTADO</td>
							<td class="text-right" style="width: 130px;">
								<p class="mb-0">VALOR UF</p>
								<p class="mb-0" style="font-size: 10px;">A fecha Pago</p>
							</td>
							<td class="text-right" style="width: 120px;">
								<p class="mb-0">A PAGAR</p>
								<p class="mb-0" style="font-size: 10px;">EN PESOS (CLP)</p>
							</td>
							<td class="text-right" style="width: 120px;">PAGADO</td>
							<td class="text-right" style="width: 110px;">DIFERENCIA</td>
							<td style="width: 150px;">OBSERVACIÓN</td>
							<td style="width: 170px;">DETALLE DE PAGOS</td>
							<td style="width: 210px;">ACCIÓN</td>
						</tr>
					</thead>
					<tbody>
						<!-- TABLA UNIFICADA: usa T1 hasta que T2 es generada -->
						<tr v-for="(quota, qi) in adjustmentSummaryDynamic" :key="'pay_unified_'+quota.uid">
							<td style="vertical-align: middle;">
								<p class="mb-0 font-weight-bold">Cuota {{ qi + 1 }}</p>
								<p class="mb-0 grey--text" style="font-size: 10px;">{{ quota.percent }}%</p>
							</td>
							<td class="text-right" style="vertical-align: middle;">
								<p class="mb-0">{{ quota.detailUf | toThousandFilter(2) }} <small>UF</small></p>
								<p class="mb-0">${{ quota.detailClp | toThousandFilter }} <small>CLP</small></p>
							</td>
							<td class="text-right" style="vertical-align: middle;">
								<p class="mb-0">${{ quota.uf_value?.uf_value | toThousandFilter(2) }}</p>
								<p class="mb-0" style="font-size: 11px;">{{ quota.uf_value?.date | toDate }}</p>
							</td>
							<td class="text-right" style="vertical-align: middle;">
								<div class="d-flex flex-column">
									<span class="font-weight-medium">
										{{ quota.toPayUf | toThousandFilter(2) }} <small>UF</small>
									</span>
									<span class="font-weight-medium">
										${{ quota.toPayClp | toThousandFilter }} <small>CLP</small>
									</span>
								</div>
							</td>
							<!-- PAGADO: read-only desde payment_orders reales -->
							<td class="text-right" style="vertical-align: middle;">
								<div class="d-flex flex-column">
									<span class="font-weight-medium" :style="{ color: quota.paidUf > 0 ? '#2e7d32' : 'inherit' }">
										{{ quota.paidUf | toThousandFilter(2) }} <small>UF</small>
									</span>
									<span class="font-weight-medium" :style="{ color: quota.paidClp > 0 ? '#2e7d32' : 'inherit' }">
										${{ quota.paidClp | toThousandFilter }} <small>CLP</small>
									</span>
								</div>
							</td>
							<!-- DIFERENCIA -->
							<td class="text-right" style="vertical-align: middle;">
								<span :style="{ color: (quota.toPayClp - quota.paidClp) > 0 ? '#FF120B' : '#2e7d32' }">
									${{ (quota.toPayClp - quota.paidClp) || 0 | toThousandFilter }}
								</span>
							</td>
							<!-- OBSERVACIÓN: v-menu con textarea -->
							<td style="vertical-align: middle;">
								<v-menu
									v-model="notesMenuOpen[qi]"
									offset-y
									min-width="280px"
									:close-on-content-click="false"
									nudge-left="20"
								>
									<template v-slot:activator="{ on, attrs }">
										<button
											class="notes-btn-supervision"
											:class="{ 'has-notes': !!localObservations[qi] }"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small>{{ localObservations[qi] ? 'mdi-note-text' : 'mdi-note-plus-outline' }}</v-icon>
											<span>{{ localObservations[qi] ? 'Ver nota' : 'Agregar' }}</span>
										</button>
									</template>
									<v-card elevation="4" style="min-width: 280px;">
										<div style="background: #524D4D; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
											<v-icon small dark>mdi-note-text</v-icon>
											<span style="color: white; font-size: 12px; font-weight: 600;">Observación — Cuota {{ qi + 1 }}</span>
										</div>
										<v-card-text style="padding: 12px;">
											<v-textarea
												v-model="localObservations[qi]"
												dense
												outlined
												rows="3"
												hide-details
												placeholder="Escribe una observación sobre esta cuota..."
												class="caption"
											></v-textarea>
											<div class="d-flex align-center justify-end mt-2" style="gap: 8px;">
												<v-btn text small color="grey darken-2" @click="closeNotesMenu(qi)">Cancelar</v-btn>
												<v-btn outlined small @click="saveObservation(qi)">Guardar</v-btn>
											</div>
										</v-card-text>
									</v-card>
								</v-menu>
							</td>
							<!-- DETALLE DE PAGOS: v-menu con listado de payment_orders -->
							<td style="vertical-align: middle;">
								<v-menu
									v-if="getQuotaPaymentOrders(quota).length > 0"
									offset-y
									:close-on-content-click="false"
									open-on-hover
								>
									<template v-slot:activator="{ on, attrs }">
										<v-chip
											x-small
											color="success"
											v-bind="attrs"
											v-on="on"
											class="mr-1"
										>
											<v-icon x-small left>mdi-check-circle</v-icon>
											{{ getQuotaPaymentOrders(quota).length }} pago{{ getQuotaPaymentOrders(quota).length !== 1 ? 's' : '' }}
										</v-chip>
									</template>
									<v-card style="min-width: 280px; max-width: 340px;">
										<div style="background: #2e7d32; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
											<v-icon small dark>mdi-cash-check</v-icon>
											<span style="color: white; font-size: 12px; font-weight: 600;">Pagos registrados — Cuota {{ qi + 1 }}</span>
										</div>
										<v-list dense class="pa-0">
											<v-list-item
												v-for="(po, poi) in getQuotaPaymentOrders(quota)"
												:key="'po_'+qi+'_'+poi"
												style="border-bottom: 1px solid #f0f0f0;"
											>
												<v-list-item-content>
													<div class="d-flex justify-space-between align-center">
														<span class="caption grey--text">Fecha</span>
														<span class="caption font-weight-bold">{{ po.payment_info.payment_date | toDate }}</span>
													</div>
													<div class="d-flex justify-space-between align-center">
														<span class="caption grey--text">Monto</span>
														<span class="caption font-weight-bold">${{ po.payment_info.amount | toThousandFilter }}</span>
													</div>
													<div class="d-flex justify-space-between align-center">
														<span class="caption grey--text">Método</span>
														<span class="caption font-weight-bold">{{ po.payment_info.method }}</span>
													</div>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-card>
								</v-menu>
								<span v-else class="grey--text caption">—</span>
							</td>
							<!-- ACCIÓN: RequestPaymentSelection -->
							<td style="vertical-align: middle;">
								<request-payment-selection
									v-if="quota.id"
									:quota="quota"
									:clp_amount="(quota.toPayClp - quota.paidClp)"
									:uf_amount="(quota.toPayUf - quota.paidUf) * (quota.percent / 100)"
									:project="project"
								></request-payment-selection>
								<v-progress-linear v-else indeterminate color="#FF120B"></v-progress-linear>
							</td>
						</tr>
						<!-- Total -->
						<tr :style="{ backgroundColor: colors['footerSupervisionTables'], color: calcFontColor(colors['footerSupervisionTables']) }">
							<td class="font-weight-bold text-right">Total</td>
							<td class="text-right font-weight-bold">${{ activePayTableTotals.totalClp | toThousandFilter }}</td>
							<td></td>
							<td></td>
							<td class="text-right font-weight-bold">
								${{ localQuotas.reduce((acc, q) => acc + getQuotaPaidAmount(q), 0) | toThousandFilter }}
							</td>
							<td class="text-right font-weight-bold">
								<span>
									${{ (activePayTableTotals.totalClp - localQuotas.reduce((acc, q) => acc + getQuotaPaidAmount(q), 0) || 0) | toThousandFilter }}
								</span>
							</td>
							<td colspan="3"></td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
			</div>
			<!-- END PAYMENT DETAIL TABLE -->
		</div>
	</v-container>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import _debounce from 'lodash/debounce'
import CompanyTemplatesHandler from '@/components/Helpers/Components/CompanyTemplatesHandler'
import RequestPaymentSelection from '@/components/Views/Projects/CostSummary/RequestPaymentSelection'
import SupervisionDiffDetailMenu from '@/components/Views/Projects/Parts/SupervisionDiffDetailMenu'
import { sendSupervisionTableToClient, getCompanyMaterials, getCompanySupervisionPercents, updateSupervisionPaymentObservation } from '@/helpers/api/costs'
import { getSinglePaymentTotalsWithTax } from '@/helpers/tablecostHelpers'

export default {
	name: 'CostSupervisionTable',
	components: { CompanyTemplatesHandler, RequestPaymentSelection, SupervisionDiffDetailMenu },
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		currency: {
			type: String,
			required: true
		},
		ufValue: {
			type: Number,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		showShowMainTable: {
			type: Boolean,
			default: true
		}
	},
  data() {
    return {
			isEditingTable1: false,
			table1Unlocked: false,
			table2Unlocked: false,
			isLoadingSendEmail: false,
			isLoadingSendEmailTable1: false,
			isLoadingSendEmailTable2: false,
			supervisionPercentA: null,
			supervisionPercentB: null,
			isDiffDetailOpen: false,
			detailOptions: [],
			percentOptions: [
				{value: 5, text: '5%'},
				{value: 10, text: '10%'},
				{value: 15, text: '15%'},
				{value: 20, text: '20%'},
				{value: 25, text: '25%'},
				{value: 30, text: '30%'},
				{value: 35, text: '35%'},
				{value: 40, text: '40%'},
				{value: 45, text: '45%'},
				{value: 50, text: '50%'},
			],
			localPayments: [],
			colWidths: ['120px','90px','90px','11%','11%','11%','11%','11%'],
      colorVars: [
        {'value': 'supervisionTableColor', 'text': 'Título /Cabecera Tabla Supervisión'},
        {'value': 'footerSupervisionTables', 'text': 'Totales Tabla Supervisión'},
      ],
      colorPickerVisible: false,
      activeColorKey: 'supervisionTableColor',
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			// Cuotas variables configurables (compartidas entre Tabla 1 y Tabla 2)
			localQuotas: [],
			// Selector de impuesto por tabla (maqueta: estado local)
			table1Tax: null,
			table2Tax: null,
			// Flag para inicialización perezosa de selectores de impuesto
			taxInitialized: false,
			// Observaciones por cuota (índice: qi)
			localObservations: {},
			// Control de menús de observación abiertos
			notesMenuOpen: {},
    };
  },
	computed: {
		localSupervisions: {
			get() {
				return (this.costsTable.supervisions || []).filter(s => s.type === 1)
			},
			// eslint-disable-next-line no-unused-vars
			set(value) {
				// Los cambios se hacen directamente en el array con type
			}
		},
		localSupervisionsB: {
			get() {
				return (this.costsTable.supervisions || []).filter(s => s.type === 2)
			},
			// eslint-disable-next-line no-unused-vars
			set(value) {
				// Los cambios se hacen directamente en el array con type
			}
		},
		difference(){
			return this.costsTable.supervisions?.difference
		},
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		todayUfValue(){
			if (!this.ufValues || !this.ufValues.length) return null
			const today = new Date().toISOString().slice(0, 10)
			return this.ufValues.find(u => u.date === today) || this.ufValues[0]
		},
		supervisionTotals(){
			const calcTotals = (list) => {
				if(!list || !list.length){
					return {supervision_first: { totalUf: 0, totalClp: 0 }, supervision_second: { totalUf: 0, totalClp: 0 }}
				}
				return list.reduce(
					(acc, supervision) => {
						const meters = Number(supervision.meters)
						const metersUf = Number(supervision.meters_uf)
						const metersClp = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0)
						const percent = (Number(supervision.percent) || 0) / 100
						const finalTaxRate = supervision.tax?.value ?? 19
						let taxMultiplier = 1 + (finalTaxRate / 100)
						if (supervision.tax?.type == 2) {
							taxMultiplier = 1 / (1 - (finalTaxRate / 100))
						}

						// Valida que existan y sean mayores que 0
						if (!isNaN(meters) && meters > 0 && !isNaN(metersUf) && metersUf > 0) {
							acc.totalUf += metersUf * meters * percent * taxMultiplier
						}

						if (!isNaN(meters) && meters > 0 && !isNaN(metersClp) && metersClp > 0) {
							acc.totalClp += metersClp * meters * percent * taxMultiplier
						}

						return acc
					},
					{ totalUf: 0, totalClp: 0 }
				)
			}

			const supervision_first = calcTotals(this.localSupervisions || [])
			const supervision_second = calcTotals(this.localSupervisionsB || [])

			const difference = {
				totalUf: Math.abs((supervision_second?.totalUf || 0) - (supervision_first?.totalUf || 0)),
				totalClp: Math.abs((supervision_second?.totalClp || 0) - (supervision_first?.totalClp || 0)),
			};

			return { supervision_first, supervision_second, difference }
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
		colors(){
			return this.$store.state.costbreakdown.costTableColorMap
		},
		supervisionTableColor() {
			return this.$store.state.costbreakdown.costTableColorMap.supervisionTableColor;
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		costsPayments(){
			return this.costsTable.payments || [];
		},
		adjustmentSummary() {
			const t1Uf = Number(this.supervisionTotals.supervision_first?.totalUf) || 0;
			const t1Clp = Number(this.supervisionTotals.supervision_first?.totalClp) || 0;
			const t2Uf = Number(this.supervisionTotals.supervision_second?.totalUf) || 0;
			const t2Clp = Number(this.supervisionTotals.supervision_second?.totalClp) || 0;

			const cuota1T1Uf = Number((t1Uf * 0.5).toFixed(2));
			const cuota1T1Clp = Math.round(t1Clp * 0.5);
			const cuota1T2Uf = Number((t2Uf * 0.5).toFixed(2));
			const cuota1T2Clp = Math.round(t2Clp * 0.5);

			const diffUf = Number((cuota1T2Uf - cuota1T1Uf).toFixed(2));
			const diffClp = Math.round(cuota1T2Clp - cuota1T1Clp);

			// Cuota 2 a pagar = 50% T2 + diferencia cuota 1 = T2 total - 50% T1
			const finalCuota2Uf = Number((cuota1T2Uf + diffUf).toFixed(2));
			const finalCuota2Clp = Math.round(cuota1T2Clp + diffClp);

			return { cuota1T1Uf, cuota1T1Clp, cuota1T2Uf, cuota1T2Clp, diffUf, diffClp, finalCuota2Uf, finalCuota2Clp };
		},
		hasSentEmailsTable1(){
			return this.costsTable.supervision_emails.some(email => email.type === 1)
		},
		hasSentEmailsTable2(){
			return this.costsTable.supervision_emails.some(email => email.type === 2)
		},
		hasSentEmails(){
			return this.hasSentEmailsTable1 || this.hasSentEmailsTable2
		},
		activePayTableTotals() {
			const t2 = this.supervisionTotalsDynamic.supervision_second
			return (t2?.totalUf > 0) ? t2 : this.supervisionTotalsDynamic.supervision_first
		},
		activePayTableNum() {
			return (this.supervisionTotalsDynamic.supervision_second?.totalUf > 0) ? 2 : 1
		},
		activePayTableLabel() {
			return (this.supervisionTotalsDynamic.supervision_second?.totalUf > 0) ? 'TABLA 2' : 'TABLA 1'
		},
		isTable1Locked(){
			return this.hasSentEmailsTable1 && !this.table1Unlocked
		},
		isTable2Locked(){
			return this.hasSentEmailsTable2 && !this.table2Unlocked
		},
		totalPayedAmount() {
			return this.localQuotas.reduce((sum, quota) => {
				return sum + this.getQuotaPaidAmount(quota)
			}, 0)
		},
		totalPayedAmountUf() {
			return this.localQuotas.reduce((sum, quota, index) => {
				return sum + this.getQuotaPaidAmountUf(quota, index)
			}, 0)
		},
		totalMetersTable1(){
			return this.localSupervisions.reduce((sum, supervision) => {
				const meters = Number(supervision.meters) || 0
				return sum + meters
			}, 0)
		},
		totalMetersTable2(){
			return this.localSupervisionsB.reduce((sum, supervision) => {
				const meters = Number(supervision.meters) || 0
				return sum + meters
			}, 0)
		},
		totalSubtotalTable1() {
			return this.localSupervisions.reduce((acc, supervision) => {
				const metersUfSubtotal = (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0)
				const metersClpSubtotal = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0)
				return {
					uf: acc.uf + metersUfSubtotal,
					clp: acc.clp + metersClpSubtotal
				}
			}, { uf: 0, clp: 0 })
		},
		totalSubtotalTable2() {
			return this.localSupervisionsB.reduce((acc, supervision) => {
				const metersUfSubtotal = (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0)
				const metersClpSubtotal = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0)
				return {
					uf: acc.uf + metersUfSubtotal,
					clp: acc.clp + metersClpSubtotal
				}
			}, { uf: 0, clp: 0 })
		},
		totalIvaTable1() {
			return this.localSupervisions.reduce((acc, supervision) => {
				const percent = supervision.percent || 0
				const metersUfIva = (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * 0.19
				const metersClpIva = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * 0.19
				return {
					uf: acc.uf + metersUfIva,
					clp: acc.clp + metersClpIva
				}
			}, { uf: 0, clp: 0 })
		},
		totalIvaTable2() {
			return this.localSupervisionsB.reduce((acc, supervision) => {
				const percent = supervision.percent || 0
				const metersUfIva = (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * 0.19
				const metersClpIva = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * 0.19
				return {
					uf: acc.uf + metersUfIva,
					clp: acc.clp + metersClpIva
				}
			}, { uf: 0, clp: 0 })
		},
		totalValuePerM2Table1() {
			return this.localSupervisions.reduce((acc, supervision) => {
				return {
					uf: acc.uf + (Number(supervision.meters_uf) || 0),
					clp: acc.clp + (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0)
				}
			}, { uf: 0, clp: 0 })
		},
		totalValuePerM2Table2() {
			return this.localSupervisionsB.reduce((acc, supervision) => {
				return {
					uf: acc.uf + (Number(supervision.meters_uf) || 0),
					clp: acc.clp + (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0)
				}
			}, { uf: 0, clp: 0 })
		},
		totalFeeTable1() {
			return this.localSupervisions.reduce((acc, supervision) => {
				const percent = supervision.percent || 0
				return {
					uf: acc.uf + (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0) * (percent / 100),
					clp: acc.clp + (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0) * (percent / 100)
				}
			}, { uf: 0, clp: 0 })
		},
		totalFeeTable2() {
			return this.localSupervisionsB.reduce((acc, supervision) => {
				const percent = supervision.percent || 0
				return {
					uf: acc.uf + (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0) * (percent / 100),
					clp: acc.clp + (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0) * (percent / 100)
				}
			}, { uf: 0, clp: 0 })
		},
		taxesOptions() {
			return this.$store.state.general.taxesOptions
		},
		table1TaxValue() {
			return this.table1Tax?.tax?.value ?? 19
		},
		table2TaxValue() {
			return this.table2Tax?.tax?.value ?? 19
		},
		totalQuotaPercent() {
			return this.localQuotas.reduce((sum, q) => sum + (Number(q.percent) || 0), 0)
		},
		totalIvaTable1Dynamic() {
			return this.localSupervisions.reduce((acc, supervision) => {
				const percent = supervision.percent || 0
				const taxRatio = (supervision.tax && supervision.tax.value || 19) / 100
				const metersUfIva = (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * taxRatio
				const metersClpIva = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * taxRatio
				return { uf: acc.uf + metersUfIva, clp: acc.clp + metersClpIva }
			}, { uf: 0, clp: 0 })
		},
		totalIvaTable2Dynamic() {
			return this.localSupervisionsB.reduce((acc, supervision) => {
				const percent = supervision.percent || 0
				const taxRatio = (supervision.tax && supervision.tax.value || 19) / 100
				const metersUfIva = (Number(supervision.meters_uf) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * taxRatio
				const metersClpIva = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0) * (Number(supervision.meters) || 0) * (percent / 100) * taxRatio
				return { uf: acc.uf + metersUfIva, clp: acc.clp + metersClpIva }
			}, { uf: 0, clp: 0 })
		},
		supervisionTotalsDynamic() {
			const calcTotals = (list) => {
				if (!list || !list.length) return { totalUf: 0, totalClp: 0 }
				return list.reduce((acc, supervision) => {
					const meters = Number(supervision.meters)
					const metersUf = Number(supervision.meters_uf)
					const metersClp = (Number(supervision.meters_uf) || 0) * ((supervision.uf_value && Number(supervision.uf_value.uf_value)) || 0)
					const percent = Number(supervision.percent) || 0
					const taxMult = 1 + ((supervision.tax && supervision.tax.value || 19) / 100)
					if (!isNaN(meters) && meters > 0 && !isNaN(metersUf) && metersUf > 0) {
						acc.totalUf += metersUf * meters * (percent / 100) * taxMult
					}
					if (!isNaN(meters) && meters > 0 && !isNaN(metersClp) && metersClp > 0) {
						acc.totalClp += metersClp * meters * (percent / 100) * taxMult
					}
					return acc
				}, { totalUf: 0, totalClp: 0 })
			}
			const supervision_first = calcTotals(this.localSupervisions)
			const supervision_second = calcTotals(this.localSupervisionsB)
			return { supervision_first, supervision_second }
		},
		adjustmentSummaryDynamic() {
			const t1Uf = Number(this.supervisionTotalsDynamic.supervision_first?.totalUf) || 0
			const t1Clp = Number(this.supervisionTotalsDynamic.supervision_first?.totalClp) || 0
			const t2Uf = Number(this.supervisionTotalsDynamic.supervision_second?.totalUf) || 0
			const t2Clp = Number(this.supervisionTotalsDynamic.supervision_second?.totalClp) || 0

			// let prevDiffUf = 0
			// let prevDiffClp = 0
			let accUf = 0
			let accClp = 0
			return this.localQuotas.map((quota, index) => {
				const ratio = (Number(quota.percent) || 0) / 100
				const t1Uf_q = Number((t1Uf * ratio).toFixed(2))
				const t1Clp_q = Math.round(t1Clp * ratio)
				const t2Uf_q = Number((t2Uf * ratio).toFixed(2))
				const t2Clp_q = Math.round(t2Clp * ratio)
				const uf_value = quota.payments && quota.payments.length > 0 ? this.getQuotaPaymentUfValue(quota) : this.todayUfValue
				
				let finalUf = 0
				let finalClp = 0
				let diffUf = 0
				let diffClp = 0
				let detailUf = t1Uf_q
				let detailClp = t1Clp_q
				let toPayUf = t1Uf_q
				let toPayClp = t1Clp_q
				let paidUf_q = this.getQuotaPaidAmountUf(quota, index)
				let paidClp_q = this.getQuotaPaidAmount(quota)

				accUf += t2Uf_q
				accClp += t2Clp_q
				if(index > 0){
					if(t2Uf){
						detailUf = t2Uf_q
						detailClp = t2Clp_q
						toPayUf = t2Uf_q
						toPayClp = t2Clp_q
					}
					// si no hay Tabla 2, mantiene los valores de t1 asignados por defecto
				}

				if(index === this.localQuotas.length - 2){
					const totalUF = Number((this.totalPayedAmountUf).toFixed(2))
					const totalCLP = Math.round(this.totalPayedAmount)
					diffUf = Number((accUf - totalUF).toFixed(2))
					diffClp = Math.round(accClp - totalCLP)
				}
				else if(index === this.localQuotas.length - 1){
					const totalUF = Number((this.totalPayedAmountUf).toFixed(2))
					const totalCLP = Math.round(this.totalPayedAmount)
					if(!totalCLP || !t2Uf){
						finalUf = t1Uf_q
						finalClp = t1Clp_q
						detailUf = t1Uf_q
						detailClp = t1Clp_q
						toPayUf = detailUf
						toPayClp = uf_value ? detailUf * uf_value.uf_value : 0
					}
					else{
						const finalDiffUF = t2Uf - totalUF
						const finalDiffCLP = t2Clp - totalCLP
						finalUf = Number((finalDiffUF).toFixed(2))
						finalClp = Math.round(finalDiffCLP)
						detailUf = finalUf
						detailClp = finalClp
						toPayUf = detailUf
						toPayClp = uf_value ? detailUf * uf_value.uf_value : 0
					}
				}

				if(index == 0){
					if(toPayClp - paidClp_q == 0){
						paidUf_q = toPayUf
					}
				}
				
				// prevDiffUf = diffUf
				// prevDiffClp = diffClp
				return {
					...quota,
					t1Uf: t1Uf_q,
					t1Clp: t1Clp_q,
					detailUf,
					detailClp,
					t2Uf: t2Uf_q,
					t2Clp: t2Clp_q,
					diffUf,
					diffClp,
					finalUf,
					finalClp,
					paidUf: paidUf_q,
					paidClp: paidClp_q,
					uf_value,
					toPayUf,
					toPayClp
				}
			})
		},
		nextSupervisionQuota() {
			if (!this.localQuotas.length) return null
			const totals = this.activePayTableTotals
			// Buscar la primera cuota con saldo pendiente o sin ningún pago
			const pending = this.localQuotas.find(quota => {
				const pactado = Math.round((totals.totalClp || 0) * (Number(quota.percent) || 0) / 100)
				const pagado = this.getQuotaPaidAmount(quota)
				return pagado === 0 || pagado < pactado
			})
			return pending || this.localQuotas[0]
		},
		nextProjectCostsPayment() {
			const payments = this.costsPayments
			if (!Array.isArray(payments) || !payments.length) return null
			const projectTables = this.costsTable.project_tables || []
			return payments.find(cp => {
				const main = getSinglePaymentTotalsWithTax(cp, this.costsTable)
				const extras = projectTables.reduce((acc, pt) => {
					const t = getSinglePaymentTotalsWithTax(cp, pt)
					return acc + (t.total_cost_uf_taxed || 0)
				}, 0)
				return (main.total_cost_uf_taxed || 0) + extras > 0
			}) || null
		},
		nextProjectPaymentTotals() {
			const cp = this.nextProjectCostsPayment
			if (!cp) return { total_cost_uf_taxed: 0, total_cost_clp_taxed: 0 }
			const projectTables = this.costsTable.project_tables || []
			const main = getSinglePaymentTotalsWithTax(cp, this.costsTable)
			const result = projectTables.reduce((acc, pt) => {
				const t = getSinglePaymentTotalsWithTax(cp, pt)
				acc.total_cost_uf_taxed += t.total_cost_uf_taxed || 0
				acc.total_cost_clp_taxed += t.total_cost_clp_taxed || 0
				return acc
			}, { total_cost_uf_taxed: main.total_cost_uf_taxed || 0, total_cost_clp_taxed: main.total_cost_clp_taxed || 0 })
			return result
		},
		nextSummaryTotals() {
			const quota = this.nextSupervisionQuota
			const totals = this.activePayTableTotals
			const supervisionUf = quota ? Number(((totals.totalUf || 0) * (Number(quota.percent) || 0) / 100).toFixed(2)) : 0
			const supervisionClp = quota ? Math.round((totals.totalClp || 0) * (Number(quota.percent) || 0) / 100) : 0
			const projectUf = Number((this.nextProjectPaymentTotals.total_cost_uf_taxed || 0).toFixed(2))
			const projectClp = Math.round(this.nextProjectPaymentTotals.total_cost_clp_taxed || 0)
			return {
				supervisionUf,
				supervisionClp,
				projectUf,
				projectClp,
				totalUf: Number((supervisionUf + projectUf).toFixed(2)),
				totalClp: supervisionClp + projectClp,
			}
		},
		nextProjectCostsPaymentIndex() {
			if (!this.nextProjectCostsPayment) return null
			const idx = this.costsPayments.indexOf(this.nextProjectCostsPayment)
			return idx === -1 ? null : idx + 1
		},
	},
	watch: {
		'costsTable.supervision_payments': {
			handler(newVal, oldVal) {
				if (!Array.isArray(newVal)) return
				const hasNewId = newVal.some((p, i) => {
					const prev = oldVal?.[i]
					return p.id !== null && p.id !== undefined &&
						(!prev || prev.id === null || prev.id === undefined)
				})
				const hasPaymentCountChange = newVal.some((p, i) => {
					return (p.payments?.length || 0) !== (oldVal?.[i]?.payments?.length || 0)
				})
				if (hasNewId || hasPaymentCountChange) {
					this.initQuotasFromCostsTable()
				}
			},
			deep: true
		},
		localQuotas: {
			handler(newVal) {
				if (!this.costsTable.supervision_payments) {
					this.$set(this.costsTable, 'supervision_payments', [])
				}
				this.costsTable.supervision_payments = newVal.map((q, qi) => ({
					id: q.id ?? null,
					name: q.name,
					percent: q.percent,
					observation: this.localObservations[qi] ?? '',
					payments: q.payments ?? [],
				}))
			},
			deep: true
		},
		localSupervisions: {
			handler() {
				this.costsTable.supervisions.difference = {...this.supervisionTotals.difference, id: null}
				this.supervisionPercentA = this.localSupervisions.length > 0 ? this.localSupervisions[0].percent : null
			},
			deep: true
		},
		localSupervisionsB: {
			handler() {
				this.costsTable.supervisions.difference = {...this.supervisionTotals.difference, id: null}
				this.supervisionPercentB = this.localSupervisionsB.length > 0 ? this.localSupervisionsB[0].percent : null
			},
			deep: true
		},
		table1Tax(newVal) {
			if (!newVal) return
			this.localSupervisions.forEach(supervision => {
				this.$set(supervision, 'tax', newVal.tax)
				this.$set(supervision, 'tax_id', newVal.tax?.id ?? null)
			})
		},
		table2Tax(newVal) {
			if (!newVal) return
			this.localSupervisionsB.forEach(supervision => {
				this.$set(supervision, 'tax', newVal.tax)
				this.$set(supervision, 'tax_id', newVal.tax?.id ?? null)
			})
		},
		taxesOptions(newVal) {
			if (!this.taxInitialized && newVal && newVal.length > 0) {
				this.initTaxSelectors()
			}
		},
		// difference: {
		// 	handler(newValue) {
		// 	},
		// 	deep: true
		// }
	},
	mounted(){
		this.loadMaterials()
		this.loadPercentages()
		this.initQuotasFromCostsTable()
		eventBus.$on('company_materials_updated', this.loadMaterials)
		eventBus.$on('company_supervision_percents_updated', this.loadPercentages)
		if(this.localSupervisions.length > 0){
			this.supervisionPercentA = this.localSupervisions[0].percent
		}
		if(this.localSupervisionsB.length > 0){
			this.supervisionPercentB = this.localSupervisionsB[0].percent
		}
		if (this.taxesOptions && this.taxesOptions.length > 0) {
			this.initTaxSelectors()
		}
	},
	beforeDestroy() {
		eventBus.$off('company_materials_updated', this.loadMaterials)
		eventBus.$off('company_supervision_percents_updated', this.loadPercentages)
	},
  methods: {
		getQuotaValue(index) {
			if(index == 0){
				return this.supervisionTotalsDynamic.supervision_first
			}
			return this.supervisionTotalsDynamic.supervision_second
		},
		initQuotasFromCostsTable() {
			const payments = this.costsTable.supervision_payments
			if (payments && payments.length > 0) {
				this.localQuotas = payments.map((p, i) => ({
					uid: p.id ?? (i + 1),
					id: p.id ?? null,
					name: p.name ?? `Cuota N°${i + 1}`,
					percent: p.percent ?? 0,
					payments: p.payments ?? [],
				}))
				const observations = {}
				payments.forEach((p, i) => {
					observations[i] = p.observation ?? ''
				})
				this.localObservations = observations
			}
		},
		initTaxSelectors() {
			const firstT1 = this.localSupervisions[0]
			if (firstT1?.tax?.id) {
				const match = this.taxesOptions.find(opt => opt.tax && opt.tax.id === firstT1.tax.id)
				if (match) this.table1Tax = match
			}
			const firstT2 = this.localSupervisionsB[0]
			if (firstT2?.tax?.id) {
				const match = this.taxesOptions.find(opt => opt.tax && opt.tax.id === firstT2.tax.id)
				if (match) this.table2Tax = match
			}
			this.taxInitialized = true
		},
		onSupervisionPercentAChange() {
			this.localSupervisions.forEach(supervision => {
				supervision.percent = this.supervisionPercentA
			})
		},
		onSupervisionPercentBChange() {
			this.localSupervisionsB.forEach(supervision => {
				supervision.percent = this.supervisionPercentB
			})
		},
		onSupervisionDetailChange(supervision) {
			const found = this.detailOptions.find(option => option.id === supervision.detail)
			if(found){
				supervision.meters_uf = found.uf_value || 0
				this.sanitizeNumber(supervision, 'meters_uf', {allowDecimal: true})
			}
			this.assignUfToSupervision(supervision)
		},
		resolveUfForSupervision(supervision) {
			if (supervision.type === 2) {
				console.log('[DEBUG] Resolviendo UF para supervisión tipo 2:', supervision, this.localSupervisions)
				const supMeters = parseFloat(supervision.meters)
				const match = this.localSupervisions.find(s =>
					s.detail === supervision.detail &&
					!isNaN(supMeters) &&
					parseFloat(s.meters) === supMeters
				)
				console.log('[DEBUG] Supervisión tipo 2 - supervisión encontrada para asignar UF:', match)
				if (match && match.uf_value) {
					return { uf_value: match.uf_value, uf_value_id: match.uf_value_id ?? (match.uf_value?.id ?? null) }
				}
			}
			return { uf_value: this.todayUfValue, uf_value_id: this.todayUfValue?.id ?? null }
		},
		assignUfToSupervision(supervision) {
			const { uf_value, uf_value_id } = this.resolveUfForSupervision(supervision)
			this.$set(supervision, 'uf_value', uf_value)
			this.$set(supervision, 'uf_value_id', uf_value_id)
		},
		onSupervisionMetersInput(supervision) {
			this.sanitizeNumber(supervision, 'meters', { allowDecimal: true })
			this.assignUfToSupervision(supervision)
		},
		async loadMaterials() {
			if (!this.selectedCompany) return
			
			try {
				const response = await getCompanyMaterials({
					company_id: this.selectedCompany.id
				})
				if (response.code === 200) {
					this.detailOptions = (response.materials || []).map(material => ({
						...material,
						text: material.name,
					}))
				}
			} catch (error) {
				console.error('Error al cargar materiales:', error)
			}
		},
		async loadPercentages() {
			if (!this.selectedCompany) return
			
			try {
				const response = await getCompanySupervisionPercents({
					company_id: this.selectedCompany.id
				})
				if (response.code === 200) {
					this.percentOptions = (response.percents || []).map(percent => ({
						value: percent.percent,
						text: `${percent.percent}%`
					}))
				}
			} catch (error) {
				console.error('Error al cargar porcentajes:', error)
			}
		},
		async templateContentSelected(template, type = 1){
			const otherTypeSupervisions = (this.costsTable.supervisions || []).filter(s => s.type !== type)
			const newSupervisions = template.map(item => ({
				...item,
				type: type
			}))
			const updatedSupervisions = [...otherTypeSupervisions, ...newSupervisions]
			this.$set(this.costsTable, 'supervisions', updatedSupervisions)
		},
		getSubtotalPaymentUf(costsPayment) {
			let sum = 0;

			const supervisionA = this.getPaymentValue(costsPayment, 'supervisionA');
			const supervisionB = this.getPaymentValue(costsPayment, 'supervisionB');

			if (supervisionB) {
				const totalUf = Number(this.supervisionTotals.supervision_second?.totalUf) || 0;
				const amount = Number(supervisionB.amount) || 0;
				sum += totalUf * (amount / 100);
				// const totalUfA = Number(this.supervisionTotals.supervision_first?.totalUf) || 0;
				// const amountA = Number(supervisionA.amount) || 0;
				// const totalUf = Number(this.supervisionTotals.supervision_second?.totalUf) || 0;
				// const amount = Number(supervisionB.amount) || 0;
				// sum = totalUf * (amount / 100) - ( totalUfA * (amountA / 100) );
			}
			else if (supervisionA) {
				const totalUf = Number(this.supervisionTotals.supervision_first?.totalUf) || 0;
				const amount = Number(supervisionA.amount) || 0;
				sum += totalUf * (amount / 100);
			}

			return Number(sum.toFixed(2));
		},
		getSubtotalPaymentClp(costsPayment) {
			let sum = 0;

			const supervisionA = this.getPaymentValue(costsPayment, 'supervisionA');
			const supervisionB = this.getPaymentValue(costsPayment, 'supervisionB');

			if (supervisionA) {
				const totalUf = Number(this.supervisionTotals.supervision_first?.totalClp) || 0;
				const amount = Number(supervisionA.amount) || 0;
				sum += totalUf * (amount / 100);
			}

			if (supervisionB) {
				const totalUf = Number(this.supervisionTotals.supervision_second?.totalClp) || 0;
				const amount = Number(supervisionB.amount) || 0;
				sum += totalUf * (amount / 100);
			}

			return Number(sum.toFixed(0));
		},
		getPaymentValue(costsPayment, paymentProjectType, typeItemId = null) {
			if (!costsPayment || !Array.isArray(costsPayment.payments)) return null;

			return costsPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			) || null;
		},
		getDifferenceUf(costsPayment) {
			const paymentA = this.getPaymentValue(costsPayment, 'supervisionA');
			const paymentB = this.getPaymentValue(costsPayment, 'supervisionB');
			const ufA = paymentA
				? (Number(this.supervisionTotals.supervision_first?.totalUf) || 0) * (Number(paymentA.amount) || 0) / 100
				: 0;
			const ufB = paymentB
				? (Number(this.supervisionTotals.supervision_second?.totalUf) || 0) * (Number(paymentB.amount) || 0) / 100
				: 0;
			return Number((ufB - ufA).toFixed(2));
		},
		preUpdateValue(costPayment, paymentProjectType, newValue, typeItemId = null){
			const ref = paymentProjectType + '_' + costPayment.id
			const component = this.$refs[ref][0]
			const prevValue = component.value
			const inputEl = component.$el.querySelector('input')

			if(newValue > 100){
				this.debounceSetMessage({
					message: 'Este porcentaje no puede ser mayor a 100%. Por favor ajústalo.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
				setTimeout(() => {
					inputEl.value = prevValue
				}, 10)
				return;
			}
			this.debounceUpdatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId)
		},
		debounceUpdatePaymentValue: _debounce(function(costPayment, paymentProjectType, newValue, typeItemId = null) {
			this.updatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId);
		}, 300),
		updatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId = null) {
			const proposedPercent = this.calculateNewPaymentPercent(paymentProjectType, newValue, costPayment, typeItemId);
			if (proposedPercent > 100) {
				const ref = paymentProjectType + '_' + costPayment.id
				const component = this.$refs[ref][0]
				const inputEl = component.$el.querySelector('input')
				inputEl.value = 100 - (proposedPercent-newValue)
				newValue = 100 - (proposedPercent-newValue)
				this.debounceSetMessage({
					message: 'El porcentaje de este elemento supera el 100%. Se ha ajustado al máximo disponible.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
			}
			if (!Array.isArray(costPayment.payments)) {
				this.$set(costPayment, 'payments', []);
			}
			let payment = costPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			);

			if (payment) {
				payment.amount = newValue;
			} else {
				const newPayment = {
					item_type: paymentProjectType,
					amount: newValue
				};
				if (typeItemId !== null) {
					newPayment.type_item_id = typeItemId;
				}
				costPayment.payments.push(newPayment);
			}
			const updatedCostsPayments = this.costsPayments?.map(cp =>
				cp.id === costPayment.id ? costPayment : cp
			);
			this.$emit('update:costsPayments', updatedCostsPayments);
		},
		calculateNewPaymentPercent(paymentProjectType, newValue, costPayment, typeItemId = null) {
			if (!Array.isArray(this.costsPayments)) return 0;

			let currentTotal = 0;

			this.costsPayments.forEach(cp => {
				if (!Array.isArray(cp.payments)) return;

				cp.payments.forEach(p => {
					const matchesType = p.item_type === paymentProjectType;
					const matchesItemId = typeItemId === null || p.type_item_id === typeItemId;

					if (matchesType && matchesItemId) {
						// Omitimos el item que vamos a actualizar
						if (cp !== costPayment) {
							const amount = parseFloat(p.amount);
							currentTotal += isNaN(amount) ? 0 : amount;
						}
					}
				});
			});

			const proposedTotal = currentTotal + parseFloat(newValue || 0);
			return proposedTotal;
		},
		validateMaxPercent(payment, localPayments) {
			let currentValue = Number(payment.payment_value_percent) || 0
			const totalWithoutCurrent = localPayments.reduce((sum, p) => {
				if (p !== payment) {
					sum += Number(p.payment_value_percent) || 0
				}
				return sum
			}, 0)
			const maxAllowed = Math.max(0, 100 - totalWithoutCurrent)
			currentValue = Math.min(currentValue, maxAllowed)
			this.$nextTick(() => {
				this.$set(payment, 'payment_value_percent', currentValue)
			})
		},
		addSupervisionPayment(){
			this.localPayments.push({
				id: null,
				payment_value_percent: null,
				second_payment_value_percent: null,
			})
		},
		deleteSupervisionPayment(payment_id, payment_index = null){
			if (payment_index !== null && payment_index !== undefined) {
				this.localPayments.splice(payment_index, 1)
			}
		},
		enforcePercentLimit(qi) {
			this.$nextTick(() => {
				const val = Number(this.localQuotas[qi].percent) || 0
				const sumOthers = this.localQuotas.reduce((acc, q, idx) => idx === qi ? acc : acc + (Number(q.percent) || 0), 0)
				const max = Math.max(0, 100 - sumOthers)
				if (val > max) this.$set(this.localQuotas[qi], 'percent', max)
			})
		},
		addQuota() {
			this.localQuotas.push({ uid: +Date.now(), id: null, name: '', percent: 0 })
		},
		deleteQuota(index) {
			this.localQuotas.splice(index, 1)
		},
		getQuotaPaidAmount(quota) {
			const orders = quota?.payments
			if (!Array.isArray(orders)) return 0
			return orders.reduce((acc, po) => acc + (po.payment_info ? (Number(po.payment_info.amount) || 0) : 0), 0)
		},
		getQuotaPaidAmountUf(quota, quota_index) {
			const orders = quota?.payments
			if (!Array.isArray(orders)) return 0
			const quota_paid = orders.reduce((acc, po) => {
				return acc + (po.payment_info ? (Number(po.payment_info.amount / po.payment_info.uf_value?.uf_value) || 0) : 0)
			}, 0)
			const quota_paid_clp = orders.reduce((acc, po) => {
				return acc + (po.payment_info ? (Number(po.payment_info.amount) || 0) : 0)
			}, 0)
			if(quota_index === 0){
				const t1Uf = Number(this.supervisionTotalsDynamic.supervision_first?.totalUf) || 0
				const t1Clp = Number(this.supervisionTotalsDynamic.supervision_first?.totalClp) || 0
				const ratio = (Number(quota.percent) || 0) / 100
				if((quota_paid_clp >= Math.floor(t1Clp * ratio)) && (quota_paid < t1Uf * ratio)){
					// Si la cuota está pagada completa (en clp) y si en uf se pagó más del valor cuota
					return Number((t1Uf * ratio).toFixed(2))
				}
			}
			return quota_paid
		},
		getQuotaPaymentOrders(quota) {
			return Array.isArray(quota?.payments) ? quota.payments.filter(po => po.payment_info) : []
		},
		getQuotaPaymentUfValue(quota) {
			const orders = this.getQuotaPaymentOrders(quota)
			if (!orders.length) return null
			return  orders[0].payment_info?.uf_value
		},
		getQuotaEffectiveUfNumericValue(quota) {
			const paymentUf = this.getQuotaPaymentUfValue(quota)
			return paymentUf ? Number(paymentUf.uf_value) : this.ufValue
		},
		saveObservation(qi) {
			this.$set(this.notesMenuOpen, qi, false)
			const quota = this.localQuotas[qi]
			if (quota?.id) {
				updateSupervisionPaymentObservation({
					supervision_payment_id: quota.id,
					observation: this.localObservations[qi] ?? null,
				}).catch(() => {})
			}
			// Dispara el watcher de localQuotas para persistir la observation
			this.$set(this.localQuotas, qi, { ...this.localQuotas[qi] })
		},
		closeNotesMenu(qi) {
			this.$set(this.notesMenuOpen, qi, false)
		},
		addSupervision(){
			if(!this.costsTable.supervisions){
				this.costsTable.supervisions = []
			}
			this.costsTable.supervisions.push({
				id: null,
				uid: + new Date(),
				type: 1,
				detail: null,
				percent: 5,
				meters: null,
				meters_uf: null,
				meters_clp: null,
				observation: null,
				tax: this.table1Tax?.tax ?? null,
				tax_id: this.table1Tax?.tax?.id ?? null,
			})
		},
		addSupervisionB(){
			if(!this.costsTable.supervisions){
				this.costsTable.supervisions = []
			}
			this.costsTable.supervisions.push({
				id: null,
				uid: + new Date(),
				type: 2,
				detail: null,
				percent: 5,
				meters: null,
				meters_uf: null,
				meters_clp: null,
				observation: null,
				tax: this.table2Tax?.tax ?? null,
				tax_id: this.table2Tax?.tax?.id ?? null,
			})
		},
		deleteSupervision(supervision){
			const index = this.costsTable.supervisions.findIndex(s => (s.id === supervision.id && supervision.id) || s.uid === supervision.uid)
			if (index === -1) return
			this.costsTable.supervisions.splice(index, 1)
		},
		deleteSupervisionB(supervision){
			const index = this.costsTable.supervisions.findIndex(s => (s.id === supervision.id && supervision.id) || s.uid === supervision.uid)
			if (index === -1) return
			this.costsTable.supervisions.splice(index, 1)
		},
		onKeyPress(event){
			if(event.target?.value > 9999999){
				event.preventDefault();
			}
		},
		validateCLP(e) {
			if (e.key === 'e') {
				e.preventDefault()
			}
			if(e.target?.value > 9999999999){
				e.preventDefault();
			}
		},
		sanitizeNumber(supervision, key, { allowDecimal = false, allowNegative = false } = {}) {
			let value = supervision[key] != null ? String(supervision[key]) : '';
			if (typeof value !== 'string') value = String(value || '');

			const isNegative = allowNegative && value.startsWith('-');

			if (allowDecimal) {
				value = value
					.replace(',', '.')
					.replace(/[^0-9.]/g, '')
					.replace(/(\.\.*)\./g, '$1')
					.replace(/^0+(?=\d)/, '')
			} else {
				value = value
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '')
			}

			if (isNegative && value !== '') {
				value = '-' + value;
			}

			this.$set(supervision, key, value || '0');

			if (allowDecimal && (value === '' || value.endsWith('.'))) {
				return;
			}

			if (key === 'meters_uf') {
				this.setItemClpValueFromUf(supervision);
			} else if (key === 'meters_clp') {
				this.setItemUfValueFromClp(supervision);
			} else if(key === 'meters') {
				this.setItemClpValueFromUf(supervision);
			}
		},
		sanitizeUF(supervision) {
			let value = supervision.meters_uf;
			const isNegative = value.startsWith('-');
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '');
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('');
			}
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			supervision = {
				...supervision,
				meters_uf: value || '0'
			};

			this.setItemClpValueFromUf(supervision)
		},
		sanitizeIntegerInput(supervision) {
			let value = supervision.meters_clp
			supervision = {
				...supervision,
				meters_clp: value
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '') || 0
			}
			this.setItemUfValueFromClp(supervision)
		},
		setItemClpValueFromUf(supervision){
			console.log('setItemClpValueFromUf: ', supervision, this.ufValue)
			const clp_value = supervision.meters_uf * ((supervision.uf_value && supervision.uf_value.uf_value) || this.ufValue)

			const index = this.localSupervisions.findIndex(s => (s.id === supervision.id && supervision.id) || s.uid === supervision.uid)
			if (index != -1){
				this.$set(this.localSupervisions[index], 'meters_clp', parseFloat(clp_value) || '0')
			}

			const indexB = this.localSupervisionsB.findIndex(s => (s.id === supervision.id && supervision.id) || s.uid === supervision.uid)
			if (indexB != -1){
				this.$set(this.localSupervisionsB[indexB], 'meters_clp', parseFloat(clp_value) || '0')
			}
		},
		setItemUfValueFromClp(supervision){
			const uf_value = supervision.meters_clp / ((supervision.uf_value && supervision.uf_value.uf_value) || this.ufValue)

			const index = this.localSupervisions.findIndex(s => (s.id === supervision.id && supervision.id) || s.uid === supervision.uid)
			if (index != -1){
				this.$set(this.localSupervisions[index], 'meters_uf', parseFloat(uf_value) || '0')
			}

			const indexB = this.localSupervisionsB.findIndex(s => (s.id === supervision.id && supervision.id) || s.uid === supervision.uid)
			if (indexB != -1){
				this.$set(this.localSupervisionsB[indexB], 'meters_uf', parseFloat(uf_value) || '0')
			}
		},
		calcFontColor(backgroundColor){
			if (!backgroundColor) return '#000';
			let hex = backgroundColor.replace('#', '');
			if (hex.length === 3) {
				hex = hex.split('').map(char => char + char).join('');
			}
			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 128 ? '#000' : '#fff';
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },
		debounceSetMessage: _debounce(function(messageData){ this.setMessage(messageData) }, 200),
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		async sendSupervisionTable1(){
			this.isLoadingSendEmailTable1 = true
			try {
				const supervisionDataWithNames = this.localSupervisions.map(item => ({
					...item,
					detail_name: this.detailOptions.find(opt => opt.id === item.detail)?.text || item.detail
				}))
				const payload = {
					project_id: this.project?.id,
					cost_project_id: this.costsTable.id,
					supervision_data: supervisionDataWithNames,
					table_number: 1
				}
				const response = await sendSupervisionTableToClient(payload)
				if(response.code === 200) {
					// Marcar como enviada en la data local
					this.costsTable.supervisions.supervisions_sent_emails = [...(this.costsTable.supervisions.supervisions_sent_emails || []), new Date().toISOString()]
					this.setMessage({
						message: 'Tabla 1 enviada correctamente al cliente',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle-outline',
						color: '#00A860',
					})
					eventBus.$emit('reloadInformation')
				} else {
					this.setMessage({
						message: 'Error al enviar la tabla 1',
						title: 'Error',
						type: 'error',
						icon: 'mdi-alert-circle-outline',
						color: '#FF120B',
					})
				}
			} catch (error) {
				console.error('Error al enviar tabla 1:', error)
				this.setMessage({
					message: 'Error al enviar la tabla 1: ' + (error?.response?.data?.message || error.message),
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
			} finally {
				this.isLoadingSendEmailTable1 = false
			}
		},
		async sendSupervisionTable2(){
			this.isLoadingSendEmailTable2 = true
			try {
				const supervisionDataWithNames = this.localSupervisionsB.map(item => ({
					...item,
					detail_name: this.detailOptions.find(opt => opt.id === item.detail)?.text || item.detail
				}))
				const payload = {
					project_id: this.project?.id,
					cost_project_id: this.costsTable.id,
					supervision_data: supervisionDataWithNames,
					table_number: 2
				}
				const response = await sendSupervisionTableToClient(payload)
				if(response.code === 200) {
					// Marcar como enviada en la data local
					this.costsTable.supervisions.supervisionsB_sent_emails = [...(this.costsTable.supervisions.supervisionsB_sent_emails || []), new Date().toISOString()]
					this.setMessage({
						message: 'Tabla 2 enviada correctamente al cliente',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle-outline',
						color: '#00A860',
					})
					eventBus.$emit('reloadInformation')
				} else {
					this.setMessage({
						message: 'Error al enviar la tabla 2',
						title: 'Error',
						type: 'error',
						icon: 'mdi-alert-circle-outline',
						color: '#FF120B',
					})
				}
			} catch (error) {
				console.error('Error al enviar tabla 2:', error)
				this.setMessage({
					message: 'Error al enviar la tabla 2: ' + (error?.response?.data?.message || error.message),
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
			} finally {
				this.isLoadingSendEmailTable2 = false
			}
		},
		async sendSupervisionTables(){
			this.isLoadingSendEmail = true
			try {
				const supervisionDataWithNames1 = this.localSupervisions.map(item => ({
					...item,
					detail_name: this.detailOptions.find(opt => opt.id === item.detail)?.text || item.detail
				}))
				const supervisionDataWithNames2 = this.localSupervisionsB.map(item => ({
					...item,
					detail_name: this.detailOptions.find(opt => opt.id === item.detail)?.text || item.detail
				}))
				const payload = {
					project_id: this.project?.id,
					cost_project_id: this.costsTable.id,
					supervision_data: [supervisionDataWithNames1, supervisionDataWithNames2],
					table_number: 3
				}
				const response = await sendSupervisionTableToClient(payload)
				if(response.code === 200) {
					// Marcar ambas como enviadas
					this.costsTable.supervisions.supervisions_sent_emails = [...(this.costsTable.supervisions.supervisions_sent_emails || []), new Date().toISOString()]
					this.costsTable.supervisions.supervisionsB_sent_emails = [...(this.costsTable.supervisions.supervisionsB_sent_emails || []), new Date().toISOString()]
					this.setMessage({
						message: 'Ambas tablas fueron enviadas correctamente al cliente',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle-outline',
						color: '#00A860',
					})
				} else {
					this.setMessage({
						message: 'Error al enviar las tablas',
						title: 'Error',
						type: 'error',
						icon: 'mdi-alert-circle-outline',
						color: '#FF120B',
					})
				}
			} catch (error) {
				console.error('Error al enviar tablas:', error)
				this.setMessage({
					message: 'Error al enviar las tablas: ' + (error?.response?.data?.message || error.message),
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
			} finally {
				this.isLoadingSendEmail = false
			}
		}
  },
};
</script>

<style scoped>
	.costbreakdown-detail-table{
		table-layout: fixed;
		width: 100%;
	}
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.action-container{
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	/deep/ .colored-supervision-select {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-input__control {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-input__slot {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-input__slot input {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-input__slot input::placeholder {
		color: var(--supervision-color) !important;
		opacity: 0.7;
	}
	/deep/ .colored-supervision-select .v-input__append-inner .v-icon {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-label {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-input__slot fieldset {
		border-color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select:hover .v-input__slot fieldset {
		border-color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select.v-input--is-focused .v-input__slot fieldset {
		border-color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-select__selection {
		color: var(--supervision-color) !important;
	}
	/deep/ .colored-supervision-select .v-select__selection--comma {
		color: var(--supervision-color) !important;
	}
	.notes-btn-supervision {
		display: flex;
		align-items: center;
		gap: 5px;
		font-size: 11px;
		font-weight: 500;
		color: #999;
		background: #f5f5f5;
		border: 1px solid #ebebeb;
		border-radius: 6px;
		padding: 5px 10px;
		cursor: pointer;
		transition: all 0.15s ease;
		white-space: nowrap;
	}
	.notes-btn-supervision:hover {
		background: #efefef;
		color: #524d4d;
		border-color: #d0d0d0;
	}
	.notes-btn-supervision.has-notes {
		color: #524d4d;
		background: #f0eeee;
		border-color: #bdbcbc;
	}
	.custom-table-cost table{
		table-layout: fixed;
		width: 100%;
	}
	td.supervision-total-col {
		background-color: #f0f0f0 !important;
		border-left: 5px solid #FF120B !important;
		font-size: 14px !important;
		color: #333 !important;
	}
	td.supervision-quota-col {
		background-color: #f0f0f0 !important;
		border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
		font-size: 13px !important;
		color: #333 !important;
	}
	tr.header-rows-custom td.supervision-total-col,
	tr.header-rows-custom td.supervision-quota-col {
		background-color: #FF120B !important;
		border-left-color: rgba(0, 0, 0, 0.25) !important;
		color: #fff !important;
	}
	.custom-table-cost table td:first-child {
		max-width: 130px !important;
		width: 130px !important;
		overflow: hidden;
	}
	.next-payment-table table td:first-child {
		max-width: unset !important;
		width: auto !important;
		overflow: visible !important;
	}
	.next-payment-table table td:last-child {
		width: 160px !important;
		min-width: 160px !important;
		text-align: right;
	}
	@media (max-width: 1399px) {
		.custom-table-cost table td:first-child {
			max-width: unset !important;
			width: unset !important;
			overflow: visible;
		}
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows-custom{
		/* background: rgb(120, 120, 120); */
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows-custom td,
	.custom-table-cost table thead tr.header-rows-custom td{
		height: 25px;
	}
	.custom-table-cost table .header-rows-custom:hover{
		/* background: rgb(103, 103, 103) !important; */
	}
	.custom-table-cost table .header-rows-custom.indigo:hover{
		background: #3f51b5 !important;
	}
	.custom-table-cost table .header-rows-custom.green:hover{
		background: #409242 !important;
	}
	.blocked-content-cost-table {
		pointer-events: none;
		opacity: 0.6;
	}
	/deep/.costbreakdown-detail-table,
	/deep/.costbreakdown-detail-table td{
		vertical-align: top;
	}
	/deep/.costbreakdown-detail-table:hover {
		background-color: rgb(235, 235, 235);
	}
</style>
<style>
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td{
		border: 1px solid #ccc;
	}
	.cst-supervision .custom-table-cost table {
		min-width: 100%;
		table-layout: fixed;
	}
	.cst-supervision .custom-table-cost table td:first-child {
		width: 130px;
		max-width: 130px;
		overflow: hidden;
	}
	.cst-supervision .next-payment-table table {
		table-layout: auto !important;
	}
	.cst-supervision .next-payment-table table td:first-child {
		width: auto !important;
		max-width: unset !important;
		overflow: visible !important;
	}
	.cst-supervision .next-payment-table table td:last-child {
		width: 160px !important;
		min-width: 160px !important;
	}
	@media (max-width: 1399px) {
		.cst-supervision .custom-table-cost table {
			table-layout: auto;
		}
		.cst-supervision .custom-table-cost table td:first-child {
			width: unset;
			max-width: unset;
			overflow: visible;
		}
	}
	.cst-supervision .custom-table-cost .v-data-table__wrapper {
		overflow-x: auto;
	}
	/* Tabla detalle pagos: siempre fixed, columnas proporcionales, sin min-width */
	.cst-supervision .payment-fixed-table table {
		table-layout: fixed !important;
		width: 100% !important;
		min-width: unset !important;
	}
	.cst-supervision .payment-fixed-table table td:first-child {
		width: auto !important;
		max-width: unset !important;
		overflow: hidden;
	}
</style>